import { ButtonLink, Container } from '../components/ui';

export function NotFoundPage() {
  return (
    <Container className="py-28 text-center">
      <h1 className="font-report text-report-section font-medium text-text-primary">
        We couldn&rsquo;t find that page
      </h1>
      <p className="mt-3 text-report-lede text-text-secondary">
        The link may be mistyped, or the page may have moved.
      </p>
      <ButtonLink className="mt-8" to="/">
        Go to the home page
      </ButtonLink>
    </Container>
  );
}
